import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import ContestService from "../services/ContestService";
import { MdEdit } from "react-icons/md";

const ContestWinnerEmail = ({ isLoggedIn }) => {
  const surveyLink = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [sortVal, setsortVal] = useState(-1);
  const contestService = new ContestService();
  const [tableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: ""
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    userName: "",
    requestedBy: ""
  });

  const [formErrors, setFormErrors] = useState({
    email: "",
    userName: ""
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
      Promise.all([fetchWinnersData()])
        .then(() => {
          // All data fetching and operations have completed
          setLoading(false); // Data has loaded, set loading to false
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false); // Set loading to false in case of an error
        });
    } else {
      isLoggedIn(false); // User is not logged in
      navigate("/login"); // Redirect to the login page
    }
  }, [isLoggedIn, navigate, setFormData]);

  function fetchWinnersData() {
    setLoading(true);
    contestService
      .GetWinnersList(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales
          }));
          setLoading(false);
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: []
          }));
          setLoading(false);
        }
      })
      .catch((error) => {
        // console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setLoading(false);
      });
  }

  const searchFilter = (e) => {
    const value = e.target.value;
    setLoading(false);
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchWinnersData();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: event.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchWinnersData();
  };

  const onPage = (event) => {
    setLoading(true);
    getLazyLoadingValues(event);
    fetchWinnersData();
  };

  const handleDialogOpen = async () => {
    setIsEdit(false);
    setOpenDialog(true);
  };

  const initialFormData = {
    email: "",
    userName: "",
    requestedBy: ""
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormData(initialFormData);
    setFormErrors({
      email: "",
      userName: ""
    });
  };

  const validateForm = (name, value) => {
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter email address.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid email address.";
          } else errors.email = "";
          /* eslint-enable */
        } else errors.email = "";
        break;
      case "userName":
        if (value.length < 1) {
          IsValid = false;
          errors.userName = "Please enter batch number.";
        } else {
          errors.userName = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type == "checkbox" ? checked : value
    }));
    validateForm(name, value);
    console.log(formData);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      try {
        formData.requestedBy = sessionStorage.getItem("userId");
        contestService
          .SendContestWinnerEmail(formData)
          .then((response) => {
            const data = response;
            setLoading(false);
            if (data.responseCode == "200") {
              setFormData(initialFormData);
              handleDialogClose();
              fetchWinnersData();
              toast.success(data.responseMessage);
            } else {
              toast.error(data.responseMessage);
            }
          })
          .catch((error) => {
            // console.error("API request failed:", error);
            toast.error("Failed to fetch data");
            setLoading(false);
          });
      } catch (error) {
        console.error("Error creating issue data:", error);
      }
    }
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Contest Winners
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        {
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            variant="contained"
            onClick={handleDialogOpen}
          >
            Send New Email
          </button>
        }
      </div>
    </div>
  );
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="DeMapping Report"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={(e) => {
                    e.sortOrder = -sortVal;
                    setsortVal(-sortVal);
                    onSort(e);
                  }}
                  className="p-datatable-responsive"
                >
                  <Column field="userName" header="User Name" sortable={true} />
                  <Column field="email" header="Email" sortable={true} />
                  <Column
                    field="requestedBy"
                    header="Requested By"
                    sortable={true}
                  />
                  <Column
                    field="requestedDate"
                    header="Requested Date"
                    sortable={true}
                  />
                </DataTable>
              </div>
            </div>

            <Dialog
              open={openDialog}
              onClose={handleDialogClose}
              className="add"
              fullWidth
            >
              <div className="modal-header">
                <h5 className="modal-title adduser">Send Email</h5>
              </div>

              <form onSubmit={handleSubmit}>
                <DialogContent>
                  <TextField
                    disabled={isEdit}
                    margin="dense"
                    label="Enter Username"
                    type="text"
                    name="userName"
                    value={formData.userName}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.userName}
                    helperText={formErrors.userName}
                  />
                  <TextField
                    disabled={isEdit}
                    margin="dense"
                    label="Enter Email"
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.email}
                    helperText={formErrors.email}
                  />
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <DialogActions>
                        <Button
                          onClick={handleDialogClose}
                          className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                          type="button"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          color="primary"
                          className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                          Submit
                        </Button>
                      </DialogActions>
                    </div>
                  </div>
                </DialogContent>
              </form>
            </Dialog>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContestWinnerEmail;
